export default __webpack_public_path__ + "static/media/shag.d748f6bc.png";